import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import bgvideo from "../../images/bgvideo.mp4";

const Error = () => {
    const videoRef = useRef(null);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const handleVideoEnd = () => {
      // Begin the black screen transition effect
      setIsTransitioning(true);
      // Delay to show the black screen for 1 second, then restart video smoothly
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0; // Reset to the start
          videoRef.current.play(); // Start playing from the beginning
        }
        setIsTransitioning(false); // Remove black screen transition
      }, 100); // Show black screen for 1 second
    };
  
    useEffect(() => {
      const video = videoRef.current;
  
      if (video) {
        // Listen for the video's `timeupdate` to detect nearing end
        const handleTimeUpdate = () => {
          if (video.duration - video.currentTime <= 1) {
            setIsTransitioning(true); // Start fading out near the end
          }
        };
  
        video.addEventListener("timeupdate", handleTimeUpdate);
        video.addEventListener("ended", handleVideoEnd); // Trigger on end
  
        // Automatically play the video on component load
        video.play();
  
        return () => {
          video.removeEventListener("timeupdate", handleTimeUpdate);
          video.removeEventListener("ended", handleVideoEnd);
        };
      }
    }, []);
    return(
       
           
   <div class="notfoundpage">
     {/* <div style={{ position: "relative", overflow: "hidden" }}>
                      <video
                        ref={videoRef}
                        playsInline
                        loop={false} // Set loop to false to control replay manually
                        muted
                        autoPlay
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity: !isTransitioning ? 1 : 0,
                          transition: "opacity 1s ease-in-out",
                        }}
                      >
                        <source src={bgvideo} type="video/mp4" />
                      </video>
            
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "black",
                          opacity: isTransitioning ? 1 : 0,
                          transition: "opacity 1s ease-in-out", // Smooth transition for fade effect
                          pointerEvents: "none", // Allow clicks to pass through
                        }}
                      />
                    </div> */}
    <h1 class="error-number">404</h1>
    <p class="error-text">Page Not Found</p>

    <Link to="/" class="btn-home">Back to Home</Link>
  </div>
 
    )

}

export default Error
